import { format }                           from 'date-fns';
import { Impacts, State, SubmitForm }       from '@/views/events/submodules/events-detail.types';
import { DEFAULT_DATE_FORMAT }              from '@/variables';

export const useEventDetailGenerateSubmit = (state: State): SubmitForm => {
  const { form } = state;

  return {
    internal: state.switch.internal,
    name: form.name,
    type: form.type,
    webPage: form.webPage,
    comment: form.comment,
    startDate: format(form.dateRange[ 0 ], DEFAULT_DATE_FORMAT),
    endDate: format(form.dateRange[ 1 ], DEFAULT_DATE_FORMAT),
    impacts: form.impacts.map((impact: Impacts) => impact.value),
  };
};
